import { useEffect } from 'react';
import { useMap } from 'react-map-gl';
import { useSelector } from 'react-redux';
import { selectedAddressLocationSelector } from '../../store/selectors/general';

export const ZoomOnLoad = ({ animate = true, address, center, boundaryData }) => {
  const { current: map } = useMap();
  const selectedAddressLocation = useSelector(selectedAddressLocationSelector);

  useEffect(() => {
    if (!map) return;

    if (selectedAddressLocation) {
      map.flyTo({
        center: [selectedAddressLocation.lon, selectedAddressLocation.lat],
        zoom: 16,
        duration: 2000,
      });
    } else if (boundaryData?.areaData?.viewport) {
      const { cen_lat, cen_lon, zoom } = boundaryData.areaData.viewport;
      map.easeTo({
        center: [cen_lon, cen_lat],
        zoom,
        duration: 1000,
      });
    } else {
      map.flyTo({
        center: center,
        zoom: 5.35,
        duration: 2000,
      });
    }
    // eslint-disable-next-line
  }, [map, address, boundaryData, selectedAddressLocation]);

  return null;
};
